import React, { useEffect, useRef, useState } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import { FormControl } from '@mui/material'
import Select, { SingleValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from '../../redux/store'
import { getPipelinebyMission } from '../../redux/pipelines/pipelineActions'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { formatTitle } from '../../utils/formatTitle'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import '../../i18n'

interface SelectPipelineProps {
  value: string
  onChange: (event: SelectChangeEvent<string>) => void
  MissionId: string
  disabled?: boolean
  disablePortalMenu?: boolean
}

const SelectPipeline: React.FC<SelectPipelineProps> = ({
  value,
  onChange,
  MissionId,
  disabled = false,
  disablePortalMenu = false,
}) => {
  const menu = useExclusiveMenu(!disablePortalMenu)
  const dispatch = useAppDispatch()
  const { idmission } = useParams<{ idmission: string; id: string }>()
  const { t } = useTranslation()
  const pipelinesList = useSelector(
    (state: RootState) => state.pipeline.PipelineResponse?.pipelines
  )
  const loading = useSelector((state: RootState) => state.pipeline.loading)

  const containerRef = useRef<HTMLDivElement | null>(null)


  useEffect(() => {
    if (MissionId) {
      dispatch(
        getPipelinebyMission({
          MissionId,
          page: 1,
          pageSize: 200,
        })
      )
    }
  }, [dispatch, MissionId])

  const options =
    pipelinesList
      ?.filter((pipeline) => {
        if (!MissionId || !pipeline.MissionId) return true
        return String(pipeline.MissionId) === String(MissionId)
      })
      .map((pipeline) => ({
        value: pipeline._id || '',
        label: formatTitle(pipeline.PipelineName || '') || '—',
      })) || []

  const selectedOption = options.find((opt) => opt.value === value) || null

  const handlePipelineChange = (
    selected: SingleValue<{ value: string; label: string }>
  ) => {
    onChange({
      target: { name: 'PipelineId', value: selected ? selected.value : '' },
    } as SelectChangeEvent<string>)
  }

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          value={selectedOption}
          onChange={handlePipelineChange}
          options={options}
          isClearable
          isLoading={loading}
          isDisabled={disabled || !!idmission}
          placeholder={t('entityForms.project.selectPipeline', {
            defaultValue: 'Select a pipeline',
          })}
          noOptionsMessage={() =>
            loading
              ? t('entitySelector.loading', 'Loading...')
              : t('entitySelector.noResults', 'No results found')
          }
          {...menu}
          styles={incyiaSelectStyles}
          isMulti={false}
        />
      </FormControl>
    </div>
  )
}

export default SelectPipeline
